<div style="height: calc(100% - 35px); overflow-y: auto">
  <ion-card
    *ngFor="let convo of conversations; trackBy: conversationTrackBy; let i = index"
    class="convo-card bordered-card"
    [draggable]="dragEnabled"
    (dragstart)="onDragStart($event, convo)"
    (dragend)="onDragEnd($event, convo)"
    [ngClass]="{ selected: isConversationSelected(convo.id), draggable: !isSidebarMode }"
  >
    <div class="flex-space-between">
      <a
        [routerLink]="[routerPath, convo.id]"
        [routerDirection]="routerDirection"
        (click)="didClickConversation(convo, i)"
        class="row-link"
      >
        <div class="title-section">
          <div style="margin-bottom: 8px" *ngIf="convo.customer">
            <img
                *ngIf="authService.tenant?.isInternalSupport && convo?.submitterUser?.photo"
                [src]="convo?.submitterUser?.photo"
                style="border-radius: 4px; width: 18px; height: 18px; margin-right: 2px; margin-bottom: -5px"
              />
              <img
                *ngIf="convo?.customer?.slackTeams?.length === 1 && convo?.customer?.slackTeams[0]?.icon"
                [src]="convo?.customer?.slackTeams[0].icon"
                style="border-radius: 4px; width: 18px; height: 18px; margin-right: 2px; margin-bottom: -5px"
              />
              
            <span class="customer-name"> {{ convo.submitterUser?.name | firstName }} in </span>
            <span class="customer-name">
              {{ convo.customer?.name }}
            </span>
          </div>
          <p class="title-text">
            {{ convo.initialMessage ? formatContent(convo, 200) : convo.title }}
            <span style="opacity: 0.5"> [#{{ convo.friendlyId }}]</span>
          </p>
          <div style="margin: 10px 0 1px 0" *ngIf="showTags && convo.tags?.length">
            <ion-badge color="light" *ngFor="let tag of convo.tags; trackBy: tagTrackBy" style="margin-right: 4px">
              <ion-label>
                {{ tag.name }}
              </ion-label>
            </ion-badge>
          </div>
        </div>
      </a>
      <ion-icon
        *ngIf="unlinkingEnabled"
        name="custom-link-unlink"
        class="padded-icon"
        style="cursor: pointer; margin: 15px 5px; color: var(--ion-color-primary); flex-shrink: 0"
        (click)="unlinkConversation(convo)"
        ngxTippy
        data-tippy-content="Remove linkage between conversations"
      ></ion-icon>
      <div *ngIf="!unlinkingEnabled"></div>
    </div>
    <div class="flex-space-between bottom-section">
      <div style="display: flex; align-items: center">
        <ion-chip
          outline
          [color]="convo.assignedToUser ? 'dark' : 'primary'"
          class="assignee-chip"
          (click)="changeAssignee(convo)"
          [hidden]="disableAssignment"
        >
          <app-avatar
            size="20"
            *ngIf="convo.assignedToUser"
            [style.width]="'20px'"
            [style.min-width]="'20px'"
            [style.height]="'20px'"
            [name]="convo.assignedToUser.name"
            [image]="convo.assignedToUser.photo"
          >
          </app-avatar>
          <ion-icon
            name="ellipse-outline"
            style="margin: -2px; opacity: 0.5; font-size: 1.4rem"
            *ngIf="!convo.assignedToUser"
          ></ion-icon>
          <span style="font-weight: 500; margin-left: 5px">
            {{ (convo.assignedToUser ? convo?.assignedToUser?.name : 'Unassigned') | firstName }}
          </span>
        </ion-chip>
        <div *ngIf="disableAssignment" style="margin-top: auto; margin-bottom: auto">
          <div
            *ngIf="convo.status === 'open'"
            class="status-label status-label-needs-response clickable"
            ngxTippy
            data-tippy-content="Needs Response"
            (click)="changeStatus(convo)"
          >
            <ion-icon name="custom-open"></ion-icon>
          </div>
          <div
            *ngIf="convo.status === 'in_progress'"
            class="status-label status-label-in-progress clickable"
            ngxTippy
            data-tippy-content="In Progress"
            (click)="changeStatus(convo)"
          >
            <ion-icon name="custom-in-progress"></ion-icon>
          </div>
          <div
            *ngIf="convo.status === 'on_hold'"
            class="status-label status-label-on-hold clickable"
            ngxTippy
            data-tippy-content="On Hold"
            (click)="changeStatus(convo)"
          >
            <ion-icon name="custom-on-hold"></ion-icon>
          </div>
          <div
            *ngIf="convo.status === 'closed'"
            class="status-label status-label-closed clickable"
            ngxTippy
            data-tippy-content="Closed"
            (click)="changeStatus(convo)"
          >
            <ion-icon name="custom-closed"></ion-icon>
          </div>
        </div>
        <app-avatar
          size="20"
          *ngIf="disableAssignment && convo.assignedToUser"
          [style.width]="'18px'"
          [style.min-width]="'18px'"
          [style.height]="'18px'"
          [style.margin]="'5px 5px 3px 4px'"
          [name]="convo.assignedToUser.name"
          [image]="convo.assignedToUser.photo"
          [ngxTippy]="'Assigned to ' + convo.assignedToUser.name"
        >
        </app-avatar>
        <div *ngIf="convo.priority && convo.priorityEmoji && convo.priorityLabel" class="tag-accessory clickable" (click)="changePriority(convo)">
          <img
            *ngIf="isURL(convo.priorityEmoji | colonToEmoji)"
            [src]="convo.priorityEmoji | colonToEmoji"
            ngxTippy
            [attr.data-tippy-content]="convo.priorityLabel"
            alt="Emoji"
            style="width: 1em"
          />
          <span
            *ngIf="!isURL(convo.priorityEmoji | colonToEmoji)"
            class="action-icon"
            ngxTippy
            [attr.data-tippy-content]="convo.priorityLabel"
          >
            {{ convo.priorityEmoji | colonToEmoji }}
          </span>
        </div>
        <div
          *ngIf="convo.status === 'on_hold' && convo.wakeUpAt"
          [ngxTippy]="'Snoozed until ' + (convo.wakeUpAt | date: 'MMM d h:mm a')"
          class="tag-accessory"
        >
          <ion-icon name="alarm-outline"></ion-icon>
        </div>
        <ion-chip
          mode="ios"
          outline
          *ngIf="convo.notes"
          class="assignee-chip"
          (click)="viewNotes(convo)"
          [ngxTippy]="'<strong>Note</strong><br>' + convo.notes"
          [tippyProps]="{
            allowHTML: true
          }"
        >
          <ion-icon name="reader" class="tag-icon"></ion-icon>
        </ion-chip>
        <div
          *ngIf="convo._externalTaskTodoCount"
          ngxTippy
          data-tippy-content="Open tasks todo"
          class="tag-accessory"
          (click)="viewTasks(convo)"
        >
          <ion-icon name="checkbox-outline"></ion-icon
          ><span style="font-size: 0.7rem; margin-left: 1px">{{ convo._externalTaskTodoCount }}</span>
        </div>
        <ng-container *ngFor="let escalation of convo.escalations">
          <ion-text
            class="tag-accessory"
            *ngIf="escalation.status === 'pending'"
            [ngxTippy]="'<strong>Escalation</strong><br>' + escalation.title"
            [tippyProps]="{
              allowHTML: true
            }"
            color="danger"
          >
            <ion-icon name="alert-circle"></ion-icon>
          </ion-text>
        </ng-container>
      </div>
      <div class="date">
        {{ displayDate(convo) }}
      </div>
    </div>
    <div class="summary-container flex-space-between" *ngIf="showSummary && convo.summary">
      <ion-icon name="sparkles-outline" style="font-size: 1.2rem; margin-right: 6px; color: goldenrod"></ion-icon>
      <span style="width: 100%">{{ convo.summary }}</span>
    </div>
    <a
      class="checkbox"
      (click)="didSelectConversation(convo, i)"
      [hidden]="disableSelection"
      [ngClass]="{ 'selected-checkbox': isConversationSelected(convo.id) }"
    >
      <ion-icon [name]="isConversationSelected(convo.id) ? 'checkbox' : 'square-outline'"></ion-icon>
    </a>
  </ion-card>
  <ion-button fill="clear" size="block" *ngIf="hasMore" color="dark" (click)="nextPage()" [hidden]="isLoading">
    Load more
  </ion-button>
  <div [hidden]="!isLoading" style="text-align: center; padding-top: 20px; opacity: 0.6">
    <ion-spinner name="crescent"></ion-spinner>
  </div>
  <div
    *ngIf="!isLoading && showEmptyState && hasInitialized && !conversations.length"
    style="text-align: center; padding: 55px 0; opacity: 0.35; font-size: 0.8rem; font-weight: 600"
  >
    <ion-icon name="file-tray-outline" class="padded-icon"></ion-icon>No conversations found
  </div>
</div>
